import "./AboutUsCardLeft.css";

const AboutUsCardLeft = ({ data }) => {
	return (
		<div className="about-us-card-left-container">
			<div className="about-us-card-left-image">
				<img
					alt={data["alt"]}
					src={require("../../assets/" + data["image"])}
					className="about-us-card-left-image-img"
				/>
			</div>
			<h4 className="about-us-card-left-text">
				{data["texts"].map((text, index) => {
					if (text["style"] === "br") {
						return <br key={index} />;
					} else if (text["style"] === "bold") {
						return (
							<span key={index} style={{ fontWeight: "bold" }}>
								{text["value"]}
							</span>
						);
					} else {
						return text["value"];
					}
				})}
			</h4>
		</div>
	);
};

export default AboutUsCardLeft;
